import { render, staticRenderFns } from "./index.vue?vue&type=template&id=386e4202&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=386e4202&prod&lang=less&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=386e4202&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e4202",
  null
  
)

export default component.exports